module.exports = __webpack_public_path__ + "img/bwg.107a3f9f.jpg";